export { default as en } from "@gethere/locales/en/common.json";
export { default as es } from "@gethere/locales/es/common.json";
export { default as fr } from "@gethere/locales/fr/common.json";
export { default as de } from "@gethere/locales/de/common.json";
export { default as he } from "@gethere/locales/he/common.json";
